export default "__VITE_ASSET__8G8hSGpj__"